import React from 'react';
import PropTypes from 'prop-types';
import { Inline } from '@styleseat/ui';
import Spinner from '../../ui/Spinner';
import { AVAILABLE_CHANNELS, CHANNELS, PLATFORM_CHANNELS } from './constants';

import {
  Button, BodyText, Stack,
} from '../../ui';
import Image from '../../shared/Image';
import { ArrowsChevronRightIcon } from '../../ui/Icons/ArrowsChevronRightIcon';

/**
 * Displays a list of Share options for the specified channels.
 */
export default function ShareMenu({
  channels,
  loading,
  urls,
  onClick,
}) {
  return (
    <Stack space={8}>
      {channels && channels.map(id => {
        const {
          icon,
          iconReplacementComponent: IconReplacementComponent,
          name,
        } = CHANNELS[id] || {};
        return CHANNELS[id] && (
          <Button
            key={id}
            appearance="text-light"
            onClick={onClick}
            clickParam={id}
            testID={`socialShare-${id}`}
            style={{
              visibility: loading ? 'hidden' : undefined,
            }}
          >
            <Inline alignItems="center" minHeight={40} maxHeight={40} space={8} data-share-url={urls?.[id]}>
              {icon && (
                <Image
                  source={{
                    uri: icon,
                    width: 32,
                    height: 32,
                  }}
                  height={32}
                  width={32}
                />
              )}
              {IconReplacementComponent && (
                <IconReplacementComponent width={32} height={32} />
              )}
              <Inline flexGrow={1}>
                <BodyText>
                  {name}
                </BodyText>
              </Inline>
              <ArrowsChevronRightIcon />
            </Inline>
          </Button>
        );
      })}
      <Spinner show={loading || !channels} />
    </Stack>
  );
}

ShareMenu.propTypes = {
  /** Channels to show in the menu. Defaults to all platform-specific channels */
  channels: PropTypes.arrayOf(PropTypes.oneOf(AVAILABLE_CHANNELS)),
  /** Whether the menu is loading. A spinner is shown when set to true */
  loading: PropTypes.bool,
  /** Called when a channel is shared */
  onClick: PropTypes.func.isRequired,
  /** Mapping from channel ID to URL */
  urls: PropTypes.object,
};

ShareMenu.defaultProps = {
  channels: PLATFORM_CHANNELS,
  loading: false,
  urls: null,
};
